import { stringify } from "qs";
import {
  getHeaders,
  makeRequest,
  fetch,
  fetchwithoutToken,
} from "$utils/utils";
import config from "./config";
import constants from "$utils/constants";

const url = config.api_url;

export const addCompany = async (params) => {
  const res = await fetch("/api/companies/create", {
    method: "POST",
    data: params,
  });
  return res;
};

// pagination
export const getCompanies = async (params) => {
  try {
    const { data } = await fetch(
      `/api/companies?${stringify(params, { arrayFormat: "brackets" })}`
    );
    return data;
  } catch (err) {
    throw new Error(err?.message);
  }
};

export const getPublicCompanies = async (params) => {
  try {
    const { data } = await fetchwithoutToken(
      `/api/public/companies?${stringify(params, { arrayFormat: "brackets" })}`
    );
    return data;
  } catch (err) {
    throw new Error(err?.message);
  }
};

export const editCompany = async (id, company) => {
  try {
    const { data } = await fetch(`/api/companies/${id}`, {
      method: "PUT",
      data: company,
    });

    return data.data;
  } catch (err) {
    return { error: err?.message || null };
  }
};

export const getCompanyById = async (id) => {
  try {
    const { data } = await fetch(`/api/companies/${id}`);
    return data.data;
  } catch (err) {
    return { error: err?.message || null };
  }
};

export const getInseeCompaniesName = async (params) => {
  try {
    const res = await makeRequest(
      `${constants.INSEE_API.SIRENE_ENDPOINT}?q=denominationUniteLegale:"${params.name}"`,
      "GET",
      undefined,
      getHeaders(process.env.REACT_APP_SIRET_ACCESS_TOKEN)
    );

    if (!res || !res.data) {
      throw new Error("Error when getting company data with name");
    }

    const options = res.data.etablissements.map((e) => ({
      name: e?.uniteLegale?.denominationUniteLegale ?? "",
      address: `${e?.adresseEtablissement?.numeroVoieEtablissement ?? ""} ${
        e?.adresseEtablissement?.typeVoieEtablissement ?? ""
      } ${e?.adresseEtablissement?.libelleVoieEtablissement ?? ""}`,
      postalCode: e?.adresseEtablissement?.codePostalEtablissement ?? "",
      city: e?.adresseEtablissement?.libelleCommuneEtablissement ?? "",
      siret: e?.siret ?? "",
    }));

    // Format return as the core database so i need {data.data :[]}
    return {
      data: options.map((o) => ({
        ...o,
        nameDisplay: `${o.name}${o.address ? ` - ${o.address}` : ""}${
          o.postalCode ? ` - ${o.postalCode}` : ""
        }${o.city ? ` - ${o.city}` : ""}`,
      })),
    };
  } catch (err) {
    return { error: err?.message || null };
  }
};

export const getCompaniesByName = async (token: string, name: string) => {
  try {
    const res = await makeRequest(
      `${url}/api/companies/search/byName?input=${name}`,
      "GET",
      undefined,
      getHeaders(token)
    );
    if (!res || !res.data || !res.data.status) {
      throw new Error("No companies found");
    }
    return res.data.data;
  } catch {
    return undefined;
  }
};
